<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<label *ngIf="label"
       [for]="theId"
       class="slds-form-element__label">
  <abbr *ngIf="isRequired" class="slds-required" title="required">* </abbr>
  {{ label }}
  <small>{{ description }}</small>
</label>
<div class="slds-form-element__control slds-input-has-icon slds-input-has-icon_right"
     style="min-width: 9.5em">
  <input #inp
         (blur)="onBlur($event)"
         (click)="onClick($event)"
         (keyup)="onKeyUp($event)"
         [id]="theId"
         [name]="theName"
         [readOnly]="isReadOnly"
         [required]="isRequired"
         [title]="theTitle"
         autocomplete="off"
         class="slds-input"
         type="text">
  <button (click)="onClearClick()"
          class="slds-button slds-button_icon slds-input__icon slds-input__icon_right" title="Clear Date">
    <svg aria-hidden="true" class="slds-button__icon slds-icon-text-light">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#date_input"></use>
    </svg>
    <span class="slds-assistive-text">Clear Date</span>
  </button>
</div>
<div class="slds-form-element__help">{{ errorMessage }}</div>
<acc-date-picker (dateSelected)="onDateSelected($event)"
                 *ngIf="showDatePicker"
                 [initialDate]="theDate"
                 [align]="align"
                 [mode]="'d'">
</acc-date-picker>
